export const TEXT_LINE_LABEL = 'text_line';
export const BLACKOUT_LABEL = 'Blackout';

export function isTextLabelName(label) {
  const l = String(label || '').toLowerCase();
  return l === 'text' || l === TEXT_LINE_LABEL || l.startsWith('text_');
}

export function isBlackoutLabelName(label) {
  return String(label || '').trim().toLowerCase() === BLACKOUT_LABEL.toLowerCase();
}

export function syntheticTextLineLabelOption() {
  return {
    id: '__synthetic_text_line__',
    name: TEXT_LINE_LABEL,
    type: 1,
    color: '100,200,255',
  };
}

export function syntheticBlackoutLabelOption() {
  return {
    id: '__synthetic_blackout__',
    name: BLACKOUT_LABEL,
    type: 1,
    color: '0,0,0',
  };
}
